export const AG_GRID_LOCALE_PT = {
  // Set Filter
  selectAll: 'Selecionar Tudo',
  selectAllSearchResults: 'Selecionar todos os resultados',
  searchOoo: 'Pesquisar...',
  blanks: 'Vazio',
  noMatches: 'Sem correspondências',

  // Number Filter & Text Filter
  filterOoo: 'Filtrar...',
  equals: 'Igual',
  notEqual: 'Diferente',
  empty: 'Escolha Um',

  // Number Filter
  lessThan: 'Menor que',
  greaterThan: 'Maior que',
  lessThanOrEqual: 'Menor ou igual a',
  greaterThanOrEqual: 'Maior ou igual a',
  inRange: 'No intervalo',
  inRangeStart: 'de',
  inRangeEnd: 'até',

  // Text Filter
  contains: 'Contém',
  notContains: 'Não contém',
  startsWith: 'Começa por',
  endsWith: 'Termina em',
  pageSizeSelectorLabel: 'Tamanho da Página:',

  // Date Filter
  dateFormatOoo: 'aaaa-mm-dd',

  // Filter Conditions
  andCondition: 'E',
  orCondition: 'OU',

  // Filter Buttons
  applyFilter: 'Aplicar',
  resetFilter: 'Repor',
  clearFilter: 'Limpar',
  cancelFilter: 'Cancelar',

  // Filter Titles
  textFilter: 'Filtro de Texto',
  numberFilter: 'Filtro Numérico',
  dateFilter: 'Filtro de Data',
  setFilter: 'Filtro de Conjunto',

  // Side Bar
  columns: 'Colunas',
  filters: 'Filtros',

  // columns tool panel
  pivotMode: 'Modo Pivô',
  groups: 'Grupos de Linhas',
  rowGroupColumnsEmptyMessage:
    'Arraste para aqui para definir grupos de linhas',
  values: 'Valores',
  valueColumnsEmptyMessage: 'Arraste para aqui para agregar valores',
  pivots: 'Rótulos de colunas',
  pivotColumnsEmptyMessage: 'Arraste para aqui para definir rótulos de colunas',

  // Header of the Default Group Column
  group: 'Grupo',

  // Other
  loadingOoo: 'A carregar...',
  noRowsToShow: 'Sem linhas para mostrar',
  enabled: 'Ativado',

  // Menu
  pinColumn: 'Fixar Coluna',
  pinLeft: 'Fixar à esquerda',
  pinRight: 'Fixar à direita',
  noPin: 'Não fixar',
  valueAggregation: 'Agregação de valores',
  autosizeThiscolumn: 'Ajustar tamanho desta coluna',
  autosizeAllColumns: 'Ajustar tamanho de todas as colunas',
  groupBy: 'Agrupar por',
  ungroupBy: 'Desagrupar por',
  resetColumns: 'Repor colunas',
  expandAll: 'Expandir Tudo',
  collapseAll: 'Fechar Tudo',
  copy: 'Copiar',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Copiar com cabeçalhos',
  paste: 'Colar',
  ctrlV: 'Ctrl+V',
  export: 'Exportar',
  csvExport: 'Exportar CSV',
  excelExport: 'Exportar Excel',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Soma',
  min: 'Mín.',
  max: 'Máx.',
  none: 'Nenhum',
  count: 'Contagem',
  avg: 'Média',
  filteredRows: 'Filtradas',
  selectedRows: 'Selecionadas',
  totalRows: 'Total de linhas',
  totalAndFilteredRows: 'Linhas',
  more: 'Mais',
  to: 'a',
  of: 'de',
  page: 'Página',
  nextPage: 'Seguinte',
  lastPage: 'Última página',
  firstPage: 'Primeira página',
  previousPage: 'Página anterior',

  // Pivoting
  pivotColumnGroupTotals: 'Total',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Gráfico Pivô e Modo Pivô',
  pivotChart: 'Gráfico Pivô',
  chartRange: 'Intervalo do Gráfico',

  columnChart: 'Colunas',
  groupedColumn: 'Agrupado',
  stackedColumn: 'Empilhado',
  normalizedColumn: 'Empilhado 100%',

  barChart: 'Barras',
  groupedBar: 'Agrupado',
  stackedBar: 'Empilhado',
  normalizedBar: 'Empilhado 100%',

  pieChart: 'Circular',
  pie: 'Circular',
  doughnut: 'Anel',

  line: 'Linha',

  xyChart: 'X Y (Dispersão)',
  scatter: 'Dispersão',
  bubble: 'Bolhas',

  areaChart: 'Área',
  area: 'Área',
  stackedArea: 'Empilhado',
  normalizedArea: 'Empilhado 100%',

  histogramChart: 'Histograma',

  // Charts
  pivotChartTitle: 'Gráfico Pivô',
  rangeChartTitle: 'Gráfico de Intervalo',
  settings: 'Definições',
  data: 'Dados',
  format: 'Formato',
  categories: 'Categorias',
  defaultCategory: '(Nenhuma)',
  series: 'Séries',
  xyValues: 'Valores X Y',
  paired: 'Modo Emparelhado',
  axis: 'Eixo',
  navigator: 'Navegador',
  color: 'Cor',
  thickness: 'Espessura',
  xType: 'Tipo X',
  automatic: 'Automático',
  category: 'Categoria',
  number: 'Número',
  time: 'Tempo',
  xRotation: 'Rotação X',
  yRotation: 'Rotação Y',
  ticks: 'Marcas',
  width: 'Largura',
  height: 'Altura',
  length: 'Comprimento',
  padding: 'Preenchimento',
  spacing: 'Espaçamento',
  chart: 'Gráfico',
  title: 'Título',
  titlePlaceholder: 'Título do gráfico - duplo clique para editar',
  background: 'Fundo',
  font: 'Tipo de letra',
  top: 'Topo',
  right: 'Direita',
  bottom: 'Fundo',
  left: 'Esquerda',
  labels: 'Rótulos',
  size: 'tamanho',
  minSize: 'Tamanho Mínimo',
  maxSize: 'Tamanho Máximo',
  legend: 'Legenda',
  position: 'Posição',
  markerSize: 'Tamanho do Marcador',
  markerStroke: 'Contorno do Marcador',
  markerPadding: 'Preenchimento do Marcador',
  itemSpacing: 'Espaçamento entre Itens',
  itemPaddingX: 'Preenchimento X do Item',
  itemPaddingY: 'Preenchimento Y do Item',
  layoutHorizontalSpacing: 'Espaçamento Horizontal',
  layoutVerticalSpacing: 'Espaçamento Vertical',
  strokeWidth: 'Espessura do Contorno',
  offset: 'Deslocamento',
  offsets: 'Deslocamentos',
  tooltips: 'Dicas',
  callout: 'Destaque',
  markers: 'Marcadores',
  shadow: 'Sombra',
  blur: 'Desfoque',
  xOffset: 'Deslocamento X',
  yOffset: 'Deslocamento Y',
  lineWidth: 'Espessura da Linha',
  normal: 'Normal',
  bold: 'Negrito',
  italic: 'Itálico',
  boldItalic: 'Negrito Itálico',
  predefined: 'Predefinido',
  fillOpacity: 'Opacidade do Preenchimento',
  strokeOpacity: 'Opacidade da Linha',
  histogramBinCount: 'Número de classes',
  columnGroup: 'Colunas',
  barGroup: 'Barras',
  pieGroup: 'Circular',
  lineGroup: 'Linha',
  scatterGroup: 'X Y (Dispersão)',
  areaGroup: 'Área',
  histogramGroup: 'Histograma',
  groupedColumnTooltip: 'Agrupado',
  stackedColumnTooltip: 'Empilhado',
  normalizedColumnTooltip: 'Empilhado 100%',
  groupedBarTooltip: 'Agrupado',
  stackedBarTooltip: 'Empilhado',
  normalizedBarTooltip: 'Empilhado 100%',
  pieTooltip: 'Circular',
  doughnutTooltip: 'Anel',
  lineTooltip: 'Linha',
  groupedAreaTooltip: 'Área',
  stackedAreaTooltip: 'Empilhado',
  normalizedAreaTooltip: 'Empilhado 100%',
  scatterTooltip: 'Dispersão',
  bubbleTooltip: 'Bolhas',
  histogramTooltip: 'Histograma',
  noDataToChart: 'Sem dados disponíveis para o gráfico.',
  pivotChartRequiresPivotMode: 'O Gráfico Pivô requer o Modo Pivô ativado.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Ligado à Grelha',
  chartUnlinkToolbarTooltip: 'Desligado da Grelha',
  chartDownloadToolbarTooltip: 'Transferir Gráfico',

  // ARIA
  ariaHidden: 'oculto',
  ariaVisible: 'visível',
  ariaChecked: 'selecionado',
  ariaUnchecked: 'não selecionado',
  ariaIndeterminate: 'indeterminado',
  ariaDefaultListName: 'Lista',
  ariaColumnSelectAll: 'Alternar Seleção de Todas as Colunas',
  ariaInputEditor: 'Editor de Entrada',
  ariaDateFilterInput: 'Campo do Filtro de Data',
  ariaFilterList: 'Lista de Filtros',
  ariaFilterInput: 'Campo do Filtro',
  ariaFilterColumnsInput: 'Campo do Filtro de Colunas',
  ariaFilterValue: 'Valor do Filtro',
  ariaFilterFromValue: 'Filtrar a partir do valor',
  ariaFilterToValue: 'Filtrar até ao valor',
  ariaFilteringOperator: 'Operador de Filtragem',
  ariaColumn: 'Coluna',
  ariaColumnList: 'Lista de Colunas',
  ariaColumnGroup: 'Grupo de Colunas',
  ariaRowSelect: 'Prima ESPAÇO para selecionar esta linha',
  ariaRowDeselect: 'Prima ESPAÇO para desmarcar esta linha',
  ariaRowToggleSelection: 'Prima Espaço para alternar a seleção da linha',
  ariaRowSelectAll: 'Prima Espaço para alternar a seleção de todas as linhas',
  ariaToggleVisibility: 'Prima ESPAÇO para alternar a visibilidade',
  ariaSearch: 'Pesquisar',
  ariaSearchFilterValues: 'Pesquisar valores de filtros',

  // ARIA LABEL FOR DIALOGS
  ariaLabelColumnMenu: 'Menu da Coluna',
  ariaLabelCellEditor: 'Editor de Célula',
  ariaLabelDialog: 'Caixa de Diálogo',
  ariaLabelSelectField: 'Selecionar Campo',
  ariaLabelTooltip: 'Dica',
  ariaLabelContextMenu: 'Menu de Contexto',
  ariaLabelSubMenu: 'Submenu',
  ariaLabelAggregationFunction: 'Função de Agregação'
};
